const fields = [
  { title: 'context & strategy', slug: 'strategy' },
  { title: 'Creative Execution', slug: 'creative' },
  { title: 'impact', slug: 'impact' },
  { title: 'details', slug: 'details' },
]
interface SideMenuProps {
  selected?: string
  onClick: (field: string) => void
}

export const SideMenuComponent = ({ selected, onClick }: SideMenuProps) => (
  <aside className="w-[288px] sticky top-0 flex flex-col bg-white rounded-3xl  p-6 shadow-[0px_4px_12px_0px_#3939391F] text-[14px] leading-[22px] font-TCCCtext font-semibold">
    {fields.map(el => (
      <button
        className={`h-8 mb-2 py-[5px] px-3 rounded-6 text-left uppercase text-[#4C4C4C] hover:text-black ${selected === el.slug && 'bg-[#DFB26D] text-black'}`}
        onClick={() => onClick(el.slug)}
      >
        {el.title}
      </button>
    ))}
  </aside>
)
